import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

export default class SocialLinkItem extends Component {
  render() {
  	const { url, name, link } = this.props;
    return (
    	<Link to={link} target="_blank">
	      <div className="SocialLinkItem">
	      	<div className="SocialLinkItem__icon">
	      		<img className="lozad" src={url} alt={name} />
	      	</div>
	      	<div className="SocialLinkItem__text">
	      		{name}
	      	</div>
	      </div>
	     </Link>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/SocialLinkItem/SocialLinkItem.js